import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import Button from '../Button';

export const MESSAGE_TYPE_MAP = {
    INFO: 'INFO',
    SUCCESS: 'SUCCESS',
    WARNING: 'WARNING',
    ERROR: 'ERROR',
};

const ICON_NAME_MAP = {
    INFO: 'info',
    SUCCESS: 'check_circle',
    WARNING: 'error',
    ERROR: 'cancel',
};

// TODO: change to font awesome
const Message = ({ type, padding, showIcon, showDismiss, onDismiss, children }) => (
    <Styled.MessageContainer data-test-id="message-container" type={type} padding={padding}>
        {showIcon && (
            <Styled.MessageIcon data-test-id="message-icon" type={type} className="material-icons">
                {ICON_NAME_MAP[type]}
            </Styled.MessageIcon>
        )}
        {children}
        {showDismiss && (
            <Styled.MessageButtonContainer>
                <Button
                    type="simple"
                    label="clear"
                    width={22}
                    iconPadding={0}
                    hasTooltip={false}
                    icon="times"
                    color="#CCCCCC"
                    backgroundColor={Styled.MESSAGE_TYPE_MAP[type].backgroundColor}
                    onHoverColor="#777777"
                    onHoverBackgroundColor={Styled.MESSAGE_TYPE_MAP[type].backgroundColor}
                    marginBottom={0}
                    onClick={() => (onDismiss ? onDismiss() : null)}
                />
            </Styled.MessageButtonContainer>
        )}
    </Styled.MessageContainer>
);

Message.propTypes = {
    type: PropTypes.oneOf(Object.values(MESSAGE_TYPE_MAP)),
    padding: PropTypes.string,
    showIcon: PropTypes.bool,
    showDismiss: PropTypes.bool,
    onDismiss: PropTypes.func,
    children: PropTypes.node,
};

Message.defaultProps = {
    type: MESSAGE_TYPE_MAP.INFO,
    padding: '8px',
    showIcon: true,
    showDismiss: true,
    onDismiss: null,
    children: null,
};

export default Message;
